export enum Tapizado {
  SENTADERA = 'sentadera',
  COMPLETA = 'completa',
  POLTRONA = 'poltrona',
  PUFF = 'puff',
}
